import React from 'react';
import { useSelector } from 'react-redux';
import { PropTypes } from 'prop-types';
import './addPaymentCardForm.scss';
import usePayment from '../../../../core/payment/usePayment';
import { getTranslation, getSelectedPaymentPlan } from '../../../../core/utils/helpers';
import useLanguage from '../../../../core/language/useLanguage';
import StripeElementsWrapper from '../../../../components/StripeElementsWrapper';
import StripeCardForm from '../../../../components/StripeCardForm';

const CheckoutForm = ({ type, consultation_id, questions, extra_questions, phone_number, isDualSubscription, risingHoroscopeId, horoscopeDataId, sign }) => {
    const { addPaymentCardRequest, payment } = usePayment();
    const { language } = useLanguage();
    const horoscope = useSelector(state => state.horoscope);
    const user = useSelector(state => state.user.userData);

    const getPaymentProperties = (paymentType) => {
        if (paymentType === 'oneOffPurchase' || paymentType === 'oneOffPurchaseMobile') {
            return {
                payment_plan_id: getSelectedPaymentPlan(payment?.selectedOneOffPaymentPlan)?.payment_plan_id,
                horoscope_id: payment.selectedOneOffPaymentPlan?.id,
                horoscope_data_id: payment.selectedOneOffPaymentPlan?.horoscopeData?.id,
            };
        }
        if (paymentType === 'consultation') {
            return {
                consultation_id,
                questions,
                extra_questions,
                phone_number,
            };
        }
        if (paymentType === 'lifeEvent') {
            return {
                horoscopeDataParts: payment?.lifeEvents,
                selectedLang: language?.selectedLanguage?.id,
            };
        }
        if (paymentType === 'yearlyHoroscope') {
            return {
                horoscopeDataId,
                sign,
            };
        }
        if (paymentType === 'horoscope') {
            return {
                payment_plan_id: payment?.selectedPlan?.id,
                horoscope_id: horoscope?.singleHoroscope?.id,
            };
        }
        return {};
    };

    const handleSubmit = ({ token, card }) => {
        const commonProperties = {
            token,
            card,
            user_id: user?.id,
            type,
            selectedLang: language?.selectedLanguage?.id,
        };

        const paymentProperties = getPaymentProperties(type);

        let finalPaymentProperties = { ...paymentProperties };
        if (isDualSubscription && risingHoroscopeId) {
            finalPaymentProperties = {
                ...paymentProperties,
                is_combo: true,
                moon_payment_plan_id: payment?.selectedPlan?.id,
                moon_horoscope_id: horoscope?.singleHoroscope?.id,
                rising_payment_plan_id: payment?.selectedPlan?.id,
                rising_horoscope_id: risingHoroscopeId,
            };
        }

        addPaymentCardRequest({ ...commonProperties, ...finalPaymentProperties });
    };

    const languageLabels = {
        cardNumberLabel: getTranslation(language, 'payment_card_form_card_number_label', 'Card Number:'),
        holdersNameLabel: getTranslation(language, 'payment_card_form_holders_name_label', "Cardholder's Name:"),
        holdersNameRequired: getTranslation(language, 'payment_card_form_holders_name_valid_required', "Please enter Cardholder's Name!"),
        expiryLabel: getTranslation(language, 'payment_card_form_card_exp_month_label', 'Expiry Date'),
        cvcLabel: getTranslation(language, 'payment_card_form_card_cvc_label', 'Security Code:'),
    };

    return (
        <StripeElementsWrapper>
            <StripeCardForm
                onSubmit={handleSubmit}
                loading={payment.isFetching}
                buttonLabel={getTranslation(language, 'payment_card_form_pay_button_label', 'Pay')}
                language={languageLabels} />
        </StripeElementsWrapper>
    );
};

CheckoutForm.propTypes = {
    type: PropTypes.string,
    consultation_id: PropTypes.string,
    questions: PropTypes.array,
    extra_questions: PropTypes.string,
    phone_number: PropTypes.string,
    isDualSubscription: PropTypes.bool,
    risingHoroscopeId: PropTypes.string,
    horoscopeDataId: PropTypes.number,
    sign: PropTypes.string,
};

CheckoutForm.defaultProps = {
    type: '',
    consultation_id: '',
    questions: [],
    extra_questions: '',
    phone_number: '',
    isDualSubscription: false,
    risingHoroscopeId: null,
    horoscopeDataId: null,
    sign: '',
};

export default CheckoutForm;
